module.exports = __webpack_public_path__ + "img/person3.a9a45001.svg";